module.exports = __webpack_public_path__ + "app-static/img/p_10.2b5804df.jpg";